import {NumberValidator} from "@/validators/NumberValidator";
import RequiredValidator from "@/validators/RequiredValidator";

export class ReportLinesRules {

	public static readonly idRules = [
		(new RequiredValidator('uiTerms.id')).validationRule(),
	];

	public static readonly textRules = [];

	public static readonly hourlyRateRules = [
		(new NumberValidator('uiTerms.hourlyRate')).validationRule(),
	];

	public static readonly dailyLumpSumRules = [
		(new NumberValidator('uiTerms.dailyLumpSum')).validationRule(),
	];

	public static readonly amountRules = [
		(new RequiredValidator('reportLine.amount')).validationRule(),
		(new NumberValidator('reportLine.amount')).validationRule(),
	];
}
